import React from 'react';
import { MapPin, X } from 'lucide-react';
import AddressSearchResults from '../AddressSearchResults';

/**
 * AddressSearchComponent - Handles address search functionality
 * 
 * This component manages the address search input, results display, and selection.
 */
const AddressSearchComponent = ({
  searchContainerRef,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  setIsAddressSelected,
  isLoadingGeolocation,
  handleClearSearch,
  searchResults,
  isSearching,
  handleAddressSelect,
  isUsingGeolocation
}) => {
  return (
    <div
      ref={searchContainerRef}
      className="relative flex-1 max-w-md mx-4"
    >
      <div className="relative w-full">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          {isLoadingGeolocation ? (
            <svg className="animate-spin h-4 w-4 text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <MapPin className="h-4 w-4 text-purple-400" />
          )}
        </div>
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Check coverage at your address..."
          value={searchQuery}
          onChange={(e) => {
            setIsAddressSelected(false);
            setSearchQuery(e.target.value);
          }}
          className="w-full py-2 pl-10 pr-10 rounded-full bg-gray-800/70 text-white placeholder-gray-400 focus:ring-2 focus:ring-purple-500 border-none text-sm transition-all focus:bg-gray-800"
          disabled={isLoadingGeolocation}
        />
        {searchQuery && (
          <button
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={handleClearSearch}
          >
            <X className="h-4 w-4 text-gray-400 hover:text-white transition-colors" />
          </button>
        )}
        
        {/* Search Results Dropdown */}
        <AddressSearchResults
          results={searchResults}
          isLoading={isSearching}
          onSelect={handleAddressSelect}
          isDarkTheme={true}
        />
      </div>
    </div>
  );
};

export default AddressSearchComponent;